module.exports = "/_next/static/images/Personalization-xs@2x-f8e54a8e2fe447564b716e4737d09a7d.webp";